module.exports = __webpack_public_path__ + "media/stylesheets/images/talentz/icon_q-45f2c7111f9e2eaf1204d4c3782895b3.svg";